import { Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface CountByKey { key: string; count: number }
interface TrendPoint { period: string; count: number }

interface Props {
  byType: CountByKey[]
  trend: TrendPoint[]
}

const IncidentCharts = ({ byType, trend }: Props) => {
  const { t } = useTranslation("global")

  const typeChart = {
    labels: byType.map(x => x.key),
    datasets: [{
      label: t("Incidencias"),
      data: byType.map(x => x.count),
      backgroundColor: "rgba(220, 53, 69, 0.7)",
      borderColor: "rgba(220, 53, 69, 1)",
      borderWidth: 1,
    }],
  }

  const trendChart = {
    labels: trend.map(x => x.period),
    datasets: [{
      label: t("Incidencias"),
      data: trend.map(x => x.count),
      backgroundColor: "rgba(13, 202, 240, 0.6)",
      borderColor: "rgba(13, 202, 240, 1)",
      borderWidth: 1,
    }],
  }

  const options = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: { y: { beginAtZero: true, ticks: { stepSize: 1 } } },
  }

  if (byType.length === 0 && trend.length === 0) return null

  return (
    <Row className="mb-3">
      {byType.length > 0 && (
        <Col md={7} className="mb-3">
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Card.Title className="fs-6 fw-semibold">{t("Incidencias por Tipo")}</Card.Title>
              <Bar data={typeChart} options={{ ...options, indexAxis: "y" as const }} />
            </Card.Body>
          </Card>
        </Col>
      )}
      {trend.length > 0 && (
        <Col md={5} className="mb-3">
          <Card className="shadow-sm border-0">
            <Card.Body>
              <Card.Title className="fs-6 fw-semibold">{t("Tendencia mensual")}</Card.Title>
              <Bar data={trendChart} options={options} />
            </Card.Body>
          </Card>
        </Col>
      )}
    </Row>
  )
}

export default IncidentCharts
